import Api from "@/services/api.js";
import vTributos from "@/components/v-tributos/v-tributos.vue";
// import vSelect from 'vue-select'
import { read } from "fs";

import dateFormatMixin from "@/mixins/dateFormatMixin";
import dataSortMixin from "@/mixins/dataSortMixin";
import form from "bootstrap-vue/es/components/form";
import HistoricoAlteracoes from "@/components/HistoricoAlteracoes/HistoricoAlteracoes.vue";
import { mapGetters} from "vuex";

export default {
  mixins: [dateFormatMixin, dataSortMixin],
  data() {
    return {
      arProduto: [],
      arProdutoFiltrado: [],
      arMudanca: [],
      arProdutosMonitorados: [],
      dadosTela: [],
      intMonitoriasAbertas: 0,
      obProdutoCadastro: [],
      strOrdem: "",
      form: {
        produto: "",
        de: "",
        ate: "",
        uf: "",
        ncm: "",
        tributo: "",
        id_arquivo: "",
        cest: ""
      },
      strPesquisa: "",
      paginate: ["arProduto"],
      blLoadingButton: true,
      acesso_simulado: localStorage.getItem("token_simulacao") ? true : false,
      itensPerPage: 10,
      bkpSubProdutos: [],
      empresaSelecionada: {
        id: 0,
        nome: "Selecione uma empresa",
        cnpj: ""
      },

    };
  },
  components: {
    vTributos,
    HistoricoAlteracoes
  },
  beforeCreate() {

  },
  created() {

  },
  mounted: function() {

  },
  computed: {
    ...mapGetters("empresa", {
      getEmpresa: "getEmpresa"
    }),

    
  },
  watch: {
	getEmpresa(){
		// this.listarProdutos(1);
	},
    
  },
  beforeDestroy() {
    this.$bus.$off("changeCompany");
  },
  methods: {
 
  }
};
